/** Un tramo del texto: igual en las dos versiones, agregado en la nueva o quitado de la anterior. */
export interface DiffPart { kind: 'same' | 'added' | 'removed'; text: string }

/** Más allá de esto (palabras × palabras) la comparación no se hace: no se congela la pantalla con respuestas enormes. */
const MAX_CELLS = 4_000_000;

/**
 * Cambios palabra por palabra entre dos textos planos (subsecuencia común más larga). Los espacios viajan pegados a la
 * palabra anterior, así que unir los tramos devuelve exactamente cada texto. `null` si los textos son demasiado largos.
 */
export function wordDiff(before: string, after: string): DiffPart[] | null {
  const a = before.match(/\S+\s*|\s+/g) ?? [];
  const b = after.match(/\S+\s*|\s+/g) ?? [];
  if (a.length * b.length > MAX_CELLS) return null;
  const key = (s: string) => s.trimEnd();
  // lcs[i][j]: largo de la subsecuencia común de a[i..] y b[j..].
  const lcs = Array.from({ length: a.length + 1 }, () => new Uint32Array(b.length + 1));
  for (let i = a.length - 1; i >= 0; i--) for (let j = b.length - 1; j >= 0; j--) lcs[i]![j] = key(a[i]!) === key(b[j]!) ? lcs[i + 1]![j + 1]! + 1 : Math.max(lcs[i + 1]![j]!, lcs[i]![j + 1]!);
  const parts: DiffPart[] = [];
  const push = (kind: DiffPart['kind'], text: string) => { const last = parts.at(-1); if (last?.kind === kind) last.text += text; else parts.push({ kind, text }); };
  let i = 0, j = 0;
  while (i < a.length && j < b.length) {
    if (key(a[i]!) === key(b[j]!)) { push('same', b[j]!); i++; j++; }
    else if (lcs[i + 1]![j]! >= lcs[i]![j + 1]!) push('removed', a[i++]!);
    else push('added', b[j++]!);
  }
  while (i < a.length) push('removed', a[i++]!);
  while (j < b.length) push('added', b[j++]!);
  return parts;
}
